import PropTypes from "prop-types"
import { LinearProgress } from "@mui/material"
import "./style.scss"

export default function AiTeammateFetchingProgress({ isFetching }) {
  return <div className="ai-teammate-fetching-progress">
    {isFetching && <LinearProgress />}
  </div>
}

AiTeammateFetchingProgress.propTypes = {
  isFetching: PropTypes.bool.isRequired,
}
